var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Export = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M8.0625 6.53751L12 2.60001M12 2.60001L15.9375 6.53751M12 2.60001V13.1M16.5 10.1H18.75C18.9489 10.1 19.1397 10.179 19.2803 10.3197C19.421 10.4603 19.5 10.6511 19.5 10.85V20.6C19.5 20.7989 19.421 20.9897 19.2803 21.1303C19.1397 21.271 18.9489 21.35 18.75 21.35H5.25C5.05109 21.35 4.86032 21.271 4.71967 21.1303C4.57902 20.9897 4.5 20.7989 4.5 20.6V10.85C4.5 10.6511 4.57902 10.4603 4.71967 10.3197C4.86032 10.179 5.05109 10.1 5.25 10.1H7.5", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
